import React, { useEffect } from "react";

import { useNavigate } from "react-router-dom";

import UserDetails from "../../../../containers/Settings/Users/UserDetails";
import LargePopupRedirect from "../../../_utils/CommonPopups/CommonLargePopupRedirect";
import ICONS from "../../../../assets/Icons";

function UserDetailsPopup({
  closeBeneAccountDetailModal,
  User_account_id,
  type,
}) {
  const navigate = useNavigate();

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <LargePopupRedirect
        headerTitle="User details"
        headerFontWeight="semibold"
        headerFontColor="text-primary"
        headertextSize="font-md"
        isfullViewrequired={true}
        fullviewbtnText="Open in full view"
        fullviewbtnType="button"
        fullviewhandleFunction={() => {
          closeBeneAccountDetailModal();
          navigate(
            `/settings/user_view_all/user_detail_page/${User_account_id}`,
          );
        }}
        fullviewisDisabled={false}
        fullviewenabledTextColor="var(--text-primary)"
        fullviewenabledBgColor="var(--primary-nav)"
        fullviewhoverOption="white"
        fullviewicon={ICONS?.REDIRECT}
        fullviewdisabledBgColor="var(--text-disabled)"
        closeiconbtnType="button"
        closeiconhandleFunction={closeBeneAccountDetailModal}
        closeiconisDisabled={false}
        closeiconenabledBgColor="var(--primary-nav)"
        closeicondisabledBgColor="var(--text-disabled)"
        closeiconhoverOption="white"
        closeicon={ICONS?.CLOSE}
        isbottomSectionneed={false}
        bottomHeaderTextNeed={false}
        isscrollRequired={true}
      >
        <UserDetails
          User_account_id={User_account_id}
          type={type}
          closeBeneAccountDetailModal={closeBeneAccountDetailModal}
        />
      </LargePopupRedirect>
    </div>
  );
}

export default UserDetailsPopup;
